/**
 * Global Permissions
 */
import { USER_STATUSES } from "@/helpers/constants";
import { isEmptyObject } from "@/helpers/ObjectHelpers";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("config", ["isEventStarted", "canJoinEventByTime", "canEnterEvent"]),
    ...mapGetters("users", ["isAdmin"]),
    /**
     * Check that the user has access to this Digital Event
     * @return {boolean|undefined}
     */
    hasAccess() {
      // Admin always has access to the Room
      if (this.isAdmin) return true;

      if (!this.$store.state.users.user || this.$store.state.users.user.user_status !== USER_STATUSES.ACTIVE) {
        return false;
      }

      let roles = this.$store.getters["users/allowedRoles"];
      if (roles && !isEmptyObject(roles)) {
        let access = [];

        Object.keys(roles).forEach(roleName => access.push(this.hasRole(roleName, roles[roleName])));

        return access.some(a => Boolean(a));
      }

      return true;
    },
    canJoinEvent() {
      return this.canEnterEvent || this.isAdmin;
    }
  },
  methods: {
    /**
     * Check that current authorized user has role
     * Examples:
     *      hasRole("Attendee") <- User has this role with any status
     *      hasRole("Attendee", "Active") <- User has this role with "Active" status
     *      hasRole("Attendee", "Disabled") <- User has this role with "Disabled" status
     * @param roleName {String} e.g. "Attendee"
     * @param roleStatus {String|Array|null} Available role status. E.g. null, "Active", ["Active", "Assigned"]
     */
    hasRole(roleName, roleStatus) {
      if (!this.$store.state.users.userRoles.length) {
        return;
      }

      roleStatus = roleStatus || null;
      let result = false;

      this.$store.state.users.userRoles.forEach(r => {
        if (r.role_name === roleName) {
          result = true;

          if (roleStatus && Array.isArray(roleStatus)) {
            result = roleStatus.includes(r.role_status);
          } else if (roleStatus) {
            result = r.role_status === roleStatus;
          }
        }
      });

      return result;
    }
  }
};
